module.exports = __webpack_public_path__ + "static/media/vision.b9157301.svg";